
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/rowSelection/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-row-selection-demo-class","pages-pages-reference-row-selection-demo-base","pages-pages-reference-row-selection-demo-selectedrowkeys","pages-pages-reference-row-selection-demo-type"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/rowSelection/index.md?type=demo')
};